import { render, staticRenderFns } from "./Safnelo-2.vue?vue&type=template&id=b35e150c&scoped=true"
import script from "./Safnelo-2.vue?vue&type=script&lang=js"
export * from "./Safnelo-2.vue?vue&type=script&lang=js"
import style0 from "./Safnelo-2.vue?vue&type=style&index=0&id=b35e150c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35e150c",
  null
  
)

export default component.exports